import React, { useState } from 'react';
import { Layout } from '../components/layout/Layout';
import { Plus, Minus } from 'lucide-react';
import { motion } from 'framer-motion';
export function FAQsPage() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: 'What does HomeLinkPro do?',
    answer: "HomeLinkPro provides subscription-based digital tools that help businesses manage customer information, schedule tasks, track performance, share files securely, and collaborate in real time. Everything runs in the cloud, so there's no software to install."
  }, {
    question: 'How does the subscription work?',
    answer: 'You choose either our Silver or Gold annual plan. Payment is taken once per year via secure Stripe checkout. Your subscription renews automatically unless you cancel before the renewal date.'
  }, {
    question: 'What digital tools are included in each plan?',
    answer: 'Silver Plan includes task scheduling, basic file sharing, user dashboard, and secure login for up to 5 team members. Gold Plan includes everything in Silver plus team collaboration tools, shared workspace, performance tracking, advanced analytics, priority support, and up to 15 team members.'
  }, {
    question: 'Is my data secure?',
    answer: 'Yes. We use bank-grade encryption for all data in transit and at rest. Our servers are hosted in secure UK data centres with 24/7 monitoring. Access is controlled through role-based permissions, and we never share your information with third parties.'
  }, {
    question: 'Where is my data stored?',
    answer: 'All data is stored securely in UK-based data centres that comply with UK data protection standards. Your information never leaves the UK.'
  }, {
    question: 'How does billing work?',
    answer: "Billing is annual. You pay once per year via Stripe, and you'll receive an email receipt immediately. Your subscription renews automatically each year unless you cancel."
  }, {
    question: 'Can I upgrade my plan?',
    answer: 'Yes, you can upgrade from Silver to Gold at any time. The price difference will be prorated, and your new features will be available immediately. Contact our support team to arrange an upgrade.'
  }, {
    question: 'What devices and browsers does HomeLinkPro support?',
    answer: 'HomeLinkPro works on any device with a modern web browser, including desktops, laptops, tablets, and smartphones. We support the latest versions of Chrome, Firefox, Safari, and Edge.'
  }, {
    question: 'How quickly does support respond?',
    answer: 'Our UK-based support team aims to respond within one working day (Monday to Friday, 9am-5pm). Gold Plan subscribers receive priority support with faster response times.'
  }, {
    question: 'Can I cancel my subscription?',
    answer: 'Yes, you can cancel at any time. There are no cancellation fees or long-term contracts. Your access will continue until the end of your current billing period.'
  }, {
    question: 'What is your refund window?',
    answer: "We offer a 14-day money-back guarantee for all new subscriptions. If you're not satisfied within the first 14 days, contact us for a full refund. After 14 days, we do not offer refunds for partial subscription periods."
  }, {
    question: 'Is there a free trial?',
    answer: 'Yes, we offer a 14-day free trial on all plans. No credit card is required to start your trial. You can explore all features before committing to a subscription.'
  }];
  return <Layout data-id="element-379">
      <div className="bg-gradient-to-br from-slate-50 to-teal-50 py-16" data-id="element-380">
        <div className="container mx-auto px-4 text-center" data-id="element-381">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-382">
            <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4" data-id="element-383">
              Frequently Asked Questions
            </h1>
            <p className="text-slate-600 max-w-2xl mx-auto text-lg" data-id="element-384">
              Everything you need to know about HomeLinkPro
            </p>
          </motion.div>
        </div>
      </div>

      <div className="container mx-auto px-4 py-20" data-id="element-385">
        <div className="max-w-3xl mx-auto space-y-4" data-id="element-386">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.05
        }} className="border border-slate-200 rounded-lg overflow-hidden bg-white shadow-sm" data-id="element-387">
              <button className="w-full flex items-center justify-between p-6 hover:bg-slate-50 transition-colors text-left" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-388">
                <span className="font-semibold text-slate-900 pr-4" data-id="element-389">
                  {faq.question}
                </span>
                {openIndex === index ? <Minus className="text-teal-600 flex-shrink-0" size={20} data-id="element-390" /> : <Plus className="text-slate-400 flex-shrink-0" size={20} data-id="element-391" />}
              </button>
              {openIndex === index && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} className="border-t border-slate-200" data-id="element-392">
                  <div className="p-6 bg-slate-50 text-slate-600 leading-relaxed" data-id="element-393">
                    {faq.answer}
                  </div>
                </motion.div>}
            </motion.div>)}
        </div>

        <div className="max-w-3xl mx-auto mt-12 text-center" data-id="element-394">
          <p className="text-slate-600 mb-4" data-id="element-395">Still have questions?</p>
          <a href="/contact" className="inline-flex items-center justify-center h-12 px-6 rounded-lg bg-teal-600 text-white font-medium hover:bg-teal-700 transition-colors" data-id="element-396">
            Contact Our Team
          </a>
        </div>
      </div>
    </Layout>;
}